(function(){
  function text(node){return node&&node.textContent?node.textContent.trim():'';}
  function cleanVatPrice(node){
    if(!node)return;
    var main=node.querySelector('.lmu-product-price__main,.lmu-search-card__price-main');
    if(!main)return;
    var copy=text(main).replace(/\s*ex\s*VAT\s*/ig,' ').replace(/\s+/g,' ').trim();
    main.innerHTML='';
    var price=document.createElement('span');
    price.textContent=copy;
    var small=document.createElement('small');
    small.textContent='VAT included';
    main.appendChild(price);
    main.appendChild(small);
    var old=node.querySelector('.lmu-product-price__inc,.lmu-search-card__price-inc');
    if(old)old.remove();
  }
  function fixVatListings(){
    return;
  }
  function fixLegacyLinks(){
    document.querySelectorAll('a[href="/pages/embroidery-printing"]').forEach(function(link){link.href='/pages/embroidery-print';});
    var brands={
      'Onna by Premier':'/collections/onna-by-premier',
      'Premier':'/collections/premier',
      'Pro RTX':'/collections/pro-rtx',
      'Uneek':'/collections/uneek',
      'AWDis':'/search?q=AWDis&type=product',
      'Tee Jays':'/collections/tee-jays',
      'Portwest':'/collections/portwest',
      'Regatta Professional':'/collections/regatta-professional',
      'Result':'/collections/result',
      'Kustom Kit':'/collections/kustom-kit'
    };
    document.querySelectorAll('.lmu-editable-brand[href="#"],.lmu-editable-brand:not([href])').forEach(function(link){
      var image=link.querySelector('img');
      var name=(image&&image.alt)||text(link);
      if(brands[name])link.href=brands[name];
    });
  }
  function init(){fixVatListings();fixLegacyLinks();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
